
import React, { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import Stripe from "components/Stripe/Stripe";

import { CardNumberElement } from "@stripe/react-stripe-js";
import { useStripe, useElements } from "@stripe/react-stripe-js";

import { Checkbox, Form, Row, Col } from "antd";
import { Button } from "components/Buttons/Buttons";
import {
    FormCheckbox,
    FormHiddenSubmitButton,
} from "components/FormItems/FlatFormItems";

import { openNotificationWithIcon } from "utils/Notification";
import { setSubmitting } from "redux/actions/loading.actions";
import { MERCHANT } from "utils/enums";


function StripeCard({
    onSave, forcePrimary,
    setupIntent, saveText,
    includePrimaryCheckbox = true,
    children
}) {
    const stripe = useStripe();
    const elements = useElements();
    const [form] = Form.useForm();
    const submitBtnRef = useRef();

    const { submitting, currentUser } = useSelector((state) => {
        return {
            currentUser: state.user.currentUser,
            submitting: state.loading.submitting,
        };
    });

    const dispatch = useDispatch();

    const handleSubmit = async (data) => {
        // We don't want to let default form submission happen here,
        // which would refresh the page.
        // event.preventDefault();

        if (!stripe || !elements) {
            console.log("Stripe or elements not loaded");
            // Stripe.js has not yet loaded.
            // Make sure to disable form submission until Stripe.js has loaded.
            return;
        }
        dispatch(setSubmitting(true));
        const isPrimary = forcePrimary ? true : data?.isPrimary ?? false;
        const result = await stripe.confirmCardSetup(setupIntent, {
            payment_method: {
                card: elements.getElement(CardNumberElement),
                billing_details: {
                    name: data.name,
                    email: currentUser?.email,
                },
                metadata: {
                    isPrimary,
                },
            },
        });
        if (result?.error) {
            // Show error to your customer (for example, insufficient funds)
            openNotificationWithIcon(
                "error",
                "Error!",
                result?.error?.message || "Network error has occured"
            );
        } else {
            // The payment has been processed!
            if (result.setupIntent.status === "succeeded") {
                // if a primary card already exists then
                // then update
                onSave?.(result.setupIntent.payment_method, isPrimary, MERCHANT.Stripe);
                // Show a success message to your customer
                // There's a risk of the customer closing the window before callback
                // execution. Set up a webhook or plugin to listen for the
                // payment_intent.succeeded event that handles any business critical
                // post-payment actions.
            }
        }
        dispatch(setSubmitting(false));
    };

    return <> <Form
        className="stripeForm"
        layout='vertical'
        form={form}
        requiredMark={false}
        onFinish={(values) => {
            handleSubmit(values);
        }}
        onFinishFailed={({ values, errorFields, outOfDate }) => {
            form.scrollToField(errorFields[0].name, {
                scrollMode: "if-needed",
                block: "center",
                behavior: "smooth",
            });
        }}
    >
        <Row gutter={[16, 16]}>
            <Col xs={24} md={children ? 12 : 24}>
                <Stripe>
                    {
                        includePrimaryCheckbox &&
                        (forcePrimary ? (
                            <Checkbox
                                name='isPrimary'
                                className='checkboxRegular'
                                checked={true}
                                style={{ marginBottom: 18, width: 0, height: 0, display: "none" }}
                            >
                                {/* Set as Primary */}
                            </Checkbox>
                        ) : (
                            <FormCheckbox
                                name='isPrimary'
                                className='checkboxRegular'
                                formItemStyles={{ marginBottom: 14 }}
                            >
                                Set as Primary
                            </FormCheckbox>
                        ))
                    }

                    <FormHiddenSubmitButton submitRef={submitBtnRef} />
                </Stripe>
            </Col>
        </Row>
        {
            children && <div style={{ marginTop: 8 }}>
                {children}
            </div>
        }
        <Button
            rounded={true}
            onClick={() => {
                submitBtnRef?.current?.click();
            }}
            disabled={!Boolean(setupIntent)}
            loading={submitting}
            style={{ marginTop: 16 }}
        >
            {saveText}
        </Button>
    </Form >
    </>
}

export default StripeCard